import { useMemo } from 'react';

import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckAwtgRanNetworkElementNames } from '@api/hitoryCheck';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_NE_NAMES } from '@constants/queryKeys';

interface IUseQueryHistoryCheckAwtgRanNeNamesParams {
	dumpHistoryId: string;
	dataModelPathId: string;
	isAwtgRanVendor?: boolean;
}

interface IUseQueryHistoryCheckAwtgRanNeNamesReturnValue {
	neNames: string[];
	neNamesOptions: TSelectOption<string>[];
	isLoadingNeNames: boolean;
}

export const useQueryHistoryCheckAwtgRanNeNames = ({
	dumpHistoryId,
	dataModelPathId,
	isAwtgRanVendor,
}: IUseQueryHistoryCheckAwtgRanNeNamesParams): IUseQueryHistoryCheckAwtgRanNeNamesReturnValue => {
	const {
		data: neNames = [],
		isLoading: isLoadingNeNames,
	} = useQuery<string[]>({
		queryFn: () => getHistoryCheckAwtgRanNetworkElementNames(dumpHistoryId, dataModelPathId),
		queryKey: [HISTORY_CHECK_NE_NAMES, 'awtg-ran', dumpHistoryId, dataModelPathId],
		enabled: [!!(dumpHistoryId && dataModelPathId && isAwtgRanVendor)],
		...refetchOptions,
	});

	const neNamesOptions = useMemo(
		() => neNames.map(name => ({ label: name, value: name })),
		[neNames],
	);

	return {
		neNames,
		neNamesOptions,
		isLoadingNeNames,
	};
};
